<template>
  <v-footer
    :app="$vuetify.breakpoint.mdAndUp"
    :inset="$vuetify.breakpoint.mdAndUp"
    class="text-center caption"
  >
    <v-row justify="center" no-gutters>
      &copy;{{ new Date().getFullYear() }} {{ copyright.label }}
      <template v-for="link in links">
        <span :key="`${link.label}-separator`" class="px-1">|</span>
        <a :key="link.url" :href="link.url" target="_blank">{{ link.label }}</a>
      </template>
    </v-row>
  </v-footer>
</template>

<script>
import appConfig from '../config/appConfig';
export default {
  name: 'AppFooter',
  data: () => ({
    links: appConfig.appFooterLinks,
    copyright: appConfig.appFooterCopyrightText
  })
};
</script>

<style lang="scss" scoped>
a:link {
  text-decoration: none;
}
footer {
  font-family: $heading-font-family;
}
</style>
